import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpSearchInputComponent from './adpSearchInput.component';

let adpSearchInputModule = angular.module('adpSearchInput', [
  uiRouter
])

.component('adpSearchInput', adpSearchInputComponent)

.name;

export default adpSearchInputModule;



// WEBPACK FOOTER //
// ./src/app/components/adpSearchInput/adpSearchInput.js